import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import {
  ColXsMdType,
  LocationFilterType,
  RemunerationFilterType,
} from '../utils/Types';
import { DEFAULT_OPTION_LOCATION } from '../utils/Constant';
import { DefaultFilter } from '../pages/remuneration/ViewRemuneration';
import LocationFilter from './LocationFilter';
import DatePicker from '../components/KDatePicker';
import moment from 'moment';

interface ITopPerformerFilterProps {
  filterData: RemunerationFilterType;
  setFilterData: (data: any) => void;
  onApplyFilters: () => void;
  setSelectedFilterData: (data: any) => void;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 6,
};

const RemunerationFilter: React.FunctionComponent<ITopPerformerFilterProps> = ({
  filterData,
  setFilterData,
  onApplyFilters,
  setSelectedFilterData,
}: ITopPerformerFilterProps) => {
  const onResetFilter = () => {
    setFilterData(DefaultFilter);
    setSelectedFilterData(DefaultFilter);
  };

  return (
    <div className="border rounded ps-3 pt-2 pe-3 pb-3">
      <Row>
        <Col xs={12} md={6}>
          <LocationFilter
            size={{
              zone: colSize,
              state: colSize,
              district: colSize,
              city: colSize,
            }}
            hideCity={true}
            hideDistrict={true}
            filterData={{
              zone: filterData.zone,
              state: filterData.state,
              district: DEFAULT_OPTION_LOCATION,
              city: DEFAULT_OPTION_LOCATION,
            }}
            setLocationFilter={(filter: LocationFilterType) => {
              setFilterData({
                ...filterData,
                zone: filter.zone,
                state: filter.state,
                district: filter.district,
                city: filter.city,
              });
            }}
            labelNames={{ zone: 'Zone', state: 'State' }}
          />
        </Col>
        <Col xs={6} md={3}>
          <DatePicker
            label="Duration"
            maxDate={moment().subtract(1, 'month').endOf('month').toDate()}
            value={filterData.duration}
            onChange={(date: any) => {
              setFilterData({
                ...filterData,
                duration: date,
              });
            }}
            format="MM-YYYY"
            yearMonth={true}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={6} md={3} className="d-flex align-items-center pt-1">
          <Button
            variant="primary"
            className="cl-btn-primary"
            onClick={() => {
              onApplyFilters();
            }}
          >
            Search
          </Button>
          <Button
            variant="outline-primary"
            className="mx-2 cl-btn-outline-primary"
            onClick={() => {
              onResetFilter();
            }}
          >
            Reset
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default RemunerationFilter;
